<nav>
  @if (!isLoggedIn()) {
    <div class="inner-nav">
      <a
        href="https://www.globalbattery.org"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div class="logo-container">
          <img
            src="https://d1sips1sizw66e.cloudfront.net/gba/images/logos/gba_logo.png"
            alt="GBA Logo"
            class="logo"
            height="26px"
            width="77.27px"
          />
        </div>
      </a>

      @if (showMenuItems()) {
        <ul class="navbar-links">
          @for (item of menuItems(); track item.label + item.route) {
            @if (shouldShowItem(item)) {
              <li>
                @if (item.options && item.options.length > 0 && !item.external) {
                  <span #dropdownTrigger>
                    <a
                      class="nav-link dropdown-trigger"
                      tabindex="0"
                    >
                      @if (item.icon) {
                        <i-feather [name]="item.icon"></i-feather>
                      }
                      <span>{{ item.label | translate }}</span>
                      <i-feather
                        name="chevron-down"
                        style="color: var(--placeholder-color)"
                      ></i-feather>
                    </a>
                  </span>

                  <lib-dropdown
                    [triggerElement]="dropdownTrigger"
                    [items]="getDropdownItems(item)"
                    (selectDropdownOption)="onDropdownItemSelect($event, item)"
                    position="below"
                    tooltipPosition="bottom"
                  ></lib-dropdown>
                } @else if (!item.external && !item.options) {
                  @if (!item.disabled) {
                    <div style="display: flex; align-items: center; gap: 0.5em">
                      <a
                        [routerLink]="item.route"
                        routerLinkActive="active"
                        queryParamsHandling="preserve"
                        class="nav-link"
                      >
                        @if (item.icon) {
                          <i-feather [name]="item.icon"></i-feather>
                        }
                        <span>{{ item.label | translate }}</span>
                      </a>
                    </div>
                  } @else {
                    <span class="dropdown-trigger disabled">
                      @if (item.icon) {
                        <i-feather [name]="item.icon"></i-feather>
                      }
                      <span style="position: relative; display: inline-block">
                        {{ item.label | translate }}
                      </span>
                    </span>
                  }
                } @else {
                  <a
                    tabindex="0"
                    [href]="item.url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="nav-link"
                  >
                    @if (item.icon) {
                      <i-feather [name]="item.icon"></i-feather>
                    }
                    <span>{{ item.label | translate }}</span>
                  </a>
                }
              </li>
            }
          }
        </ul>
      }
    </div>
  } @else {
    <div></div>
  }
  @if (isLoggedIn()) {
    <app-user-menu></app-user-menu>
  }
</nav>
